const body = document.querySelector('body')
const menu = document.querySelector('body .o-header .menu-panel')

document.addEventListener('click', (e) => {
  const target = e.target.closest('.open-menu, .close-menu')
  if (!target) return
  body.classList.toggle('hide-bot')
  console.log('menu');
  menu.classList.toggle('menu-open')
})
